<template>
    <div>

        <v-dialog v-model="dialog" persistent max-width="70%">
            <template v-slot:activator="{ on, attrs }">

                <v-btn color="warning" small v-bind="attrs" v-on="on">
                    <v-icon>edit</v-icon>
                </v-btn>
                <v-btn class="mx-2" color="error" small @click="remove()" v-if="data.hasUserActivity === false">
                    <v-icon>remove</v-icon>
                </v-btn>

            </template>

            <v-card v-if="dialog">
                <v-card-title>
                    <span class="text-h5"> {{ trans('activities.name') }}
                        <template v-if="data.name != null">
                            - {{ data.name }}
                        </template>
                    </span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form ref="form" v-model="valid">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="12">
                                        <br>
                                    </v-col>
                                </v-row>
                                <v-row>

                                    <v-col cols="6" md="6">

                                        <v-text-field v-model="data.name" :label="trans('activities.fields.name')+'*'"
                                            :counter="80" required :rules="FormRuleHelper.stringRule(data.name, true, 3, 80)">
                                        </v-text-field>

                                    </v-col>
                                    <v-col cols="6" md="6">
                                        <v-text-field v-model="data.deadline" :label="trans('activities.fields.deadline')+'*'" type="date" required :rules="FormRuleHelper.requireRule(data.deadline)">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>

                                    <v-col cols="6" md="6">
                                        <v-text-field v-model="data.allocated_time"
                                            :label="trans('activities.fields.allocated_time')+'*'" type="number" required :rules="FormRuleHelper.numericRule(data.allocated_time, true, 1)">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="12" class="inputBlock">
                                        <v-textarea v-model="data.description"
                                            :label="trans('activities.fields.description')" :counter="255" :rules="FormRuleHelper.stringRule(data.description, false, null, 255)"></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-container>
                    <small><b>*</b>&nbsp;{{ trans('common.required-field') }}</small>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="gray" @click="annulla()">
                        <v-icon left>undo</v-icon>
                        {{ trans('activities.actions.cancel') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" :disabled="!canSubmit" @click="submit()">
                        {{ trans('activities.actions.ok') }}
                    </v-btn>

                </v-card-actions>
            </v-card>

        </v-dialog>

        <v-snackbar color="success" top :timeout="2000" v-model="snackbar">
            {{ trans('activities.actions.results.saved') }}
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                    {{ trans('activities.actions.close') }}
                </v-btn>
            </template>
        </v-snackbar>


    </div>
</template>

<script>

import FormRuleHelper from '../../../FormRuleHelpers.js';



export default {

    name: "activity-edit",

    props: {
        activity: { type: Object },
        form_error: { default: '' },
        open_dialog: { default: false}

    },
    data() {

        // let data = {}; // - add default schema
        // data = Object.assign(data, this.value || {});

        let data = this.activity;
            let dialog = (this.open_dialog) ? true : false;

        return {
            data,
            dialog,
            valid: false,
            changed: false,
            snackbar: false,
            FormRuleHelper
        };
    },
    methods: {


        remove() {
            if (confirm(trans('activities.actions.remove_question') + ' ' + this.data.name + " ?")) {
                this.$emit("removeActivity", this.data);
            }
        },



        submit() {
                        this.dialog = false;
        },


        annulla() {
            this.dialog = false;
            if((!this.changed && (this.data.name === '' || this.data.name === null)) || (this.changed && this.valid === false) ) {
                this.$emit("removeActivity", this.data);
            }


        },




    },

    computed: {
        canSubmit() {
            return this.changed && this.valid;
        },

    },



    watch: {

        data: {
            deep: true,
            handler() {
                this.changed = true;

            }
        }

    },


}
</script>

